/* eslint-disable eqeqeq */
// 3rd-party modules
import { message } from "antd";
import { useEffect, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

// project modules
import { apiCall } from "../../../helpers/apiHelper";
import Button from "../../shared/button";
import { convertToSnakecase } from "../../../helpers/objectHelper";
import Loader from "../../shared/loader";
import yup from "../../../plugins/yup";

// apis
import * as DashApi from '../../../apis/dashApi';

// models
import { Account } from "../../../models/account";
import { AccountKiboshDevice } from "../../../models/accountKiboshDevice";
import { ApiResponse } from "../../../models/response";
import Select from "../../shared/inputs/select";
import Checkbox from "../../shared/inputs/checkbox";
import { KiboshDeviceEmailAlert } from "../../../models/kiboshDeviceEmailAlert";
import { SelectProps } from "antd/lib";

type Props = {
  account?: Account;
  accountKiboshDevice: AccountKiboshDevice;
  notificationType: string ;
  refresh?: boolean;
  onCancel?: () => void;
  onSave?: (account: Account) => void;
};

export default function KiboshDeviceEmailAlerts({ account, refresh, accountKiboshDevice, notificationType, onCancel, onSave }: Props) {
  const [loading, setLoading] = useState(false);
  const abortController = new AbortController();


  const [enabled, setEnabled] = useState(false)
  const [emails, setEmails] = useState<string[]>([])
  const [currentData, setCurrentData] = useState<any>({})



  useEffect(() => {
    getAccountKiboshDeviceStatusAsync();
  }, []);
  



  const getAccountKiboshDeviceStatusAsync = async () => {

    setLoading(true)

    const data = await getAccountKiboshDeviceStatus();

    const currentData = {
      notification_enabled: data?.kiboshDevice?.notification_email_types_enabled[notificationType] || false,
      notification_email_addresses: data?.kiboshDevice?.notification_email_addresses[notificationType] || [],
      notification_type: notificationType,
      kibosh_device_id: accountKiboshDevice?.kiboshDeviceTypeCode == "dns" ? accountKiboshDevice?.kiboshDeviceReference : accountKiboshDevice?.accountKiboshDeviceId?.toString() || accountKiboshDevice?.kiboshDeviceReference!,
      kiboshDeviceReference: accountKiboshDevice?.kiboshDeviceTypeCode == "dns" ? accountKiboshDevice?.kiboshDeviceReference : accountKiboshDevice?.accountKiboshDeviceId?.toString() || accountKiboshDevice?.kiboshDeviceReference!
    }
    setEmails(currentData.notification_email_addresses)
    setEnabled(currentData.notification_enabled)
    setCurrentData(currentData);

    setLoading(false);
  }
  

  const getAccountKiboshDeviceStatus = async () => {
    let kdId = accountKiboshDevice?.kiboshDeviceTypeCode == "dns" ? accountKiboshDevice?.kiboshDeviceReference : accountKiboshDevice?.accountKiboshDeviceId?.toString() || accountKiboshDevice?.kiboshDeviceReference!
    const response = await apiCall(DashApi.getKiboshDeviceStatus(kdId, abortController.signal));

    return response.success ? response.data?.value : null;
  };
 
  const doSubmit = async (newEmails:string[], newEnabled:boolean) => {

    // validation
    let validated = true;
    let error = ""
    if( 0 == newEmails.length && newEnabled ) {
      if(emails.length ==  0) {
        validated = false; 
        error = "One or more email addresses are required"
      }
      newEnabled = false;
      setEnabled(false)
    }
    for(let ei=0; ei < newEmails.length && validated; ei++) {
      let email = newEmails[ei]
      if( !email.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/) ) {
       validated = false;
       error = "Invalid email address: '" + email + "'"
     }
    }
    if(!validated) {
      message.error(error);
    } else {

      setLoading(true);

      let cd = currentData;
      cd.notification_enabled = newEnabled
      cd.notification_email_addresses = newEmails

      let data = convertToSnakecase(cd, [], ["kiboshDeviceReference"]);

      const response: ApiResponse = await apiCall(DashApi.updateKiboshDeviceEmailAlert(data, abortController.signal));
      if (response.success) {
        message.success(`Email alert updated successfully.`);

        getAccountKiboshDeviceStatusAsync();

        if (onSave) onSave(response.data?.value);

      } else {
        message.error(response.error?.value);
      }

      setLoading(false);

    }


  };

  const titleText = () => {
    let titles: {[key:string]: string} = {
      "connection_status" : "Offline Alerts",
      "explicit" : "Accountability Alerts",
      "new_device" : "New Device Alerts"
    }
    return (titles[notificationType]) as string ;
  } 

  
  const onEnabledChange = async (e:any) => {
    
    setEnabled( !enabled ) 
    doSubmit(emails, !enabled)
  };
  
  const onEmailChange = async (e:any) => {
    setEmails(e)
    doSubmit(e, enabled)
  }

  return (
    <>
      {loading &&
        <Loader />
      }
          <group data-gap="15" data-space='15'>
            <group data-space-right='20'  data-gap="10" data-direction="column" width='auto'>
              <text data-weight="700" data-text-size="large" data-wrap="wrap" data-color="main-dark">{ titleText() }</text>
              <Checkbox
                name="notification_enabled"
                label="Enable/Disable"
                checked={ enabled }
                onChange={onEnabledChange}
                minimal
                dataLength="auto" />
              <Select
                label="Enter email to be alerted"
                dataLength='500'
                name="notification_email_addresses"
                tokenSeparators={[","]}
                allowSearch={true}
                maxCount={3}
                mode="tags"
                notFoundContent={null}
                suffixIcon={null}
                options={emails}
                value={emails}
                dropdownStyle={{ display: "none" }} // Hide dropdown
                onChange={onEmailChange}
              />
              <text data-wrap="wrap">To enter more than one, seperate with commas.</text>

              <Button data-length="200" primary onClick={ () => doSubmit(emails, enabled) }>
                <text>Update Emails</text>
              </Button>
            </group>
        </group>
    </>
  );
}
